import _ from 'lodash';
import type {
  ClinicNotificationCountQuery,
  ClinicNotificationCountQueryVariables,
} from '@/shared/api';

import { createClient } from '@/shared/api';
import CLINIC_NOTIFICATION_COUNT_QUERY from '../queries/clinicNotificationCount';

/**
 * Loads the number of clinic notifications matching an optional filter. Runs the clinicNotificationCount query and throws the first GraphQL error only when the count is missing.
 *
 * @param filter - Optional filter narrowing the counted notifications.
 * @returns A promise resolving to the clinic notification count payload.
 */
const fetchClinicNotificationCount = async (filter?: Record<string, unknown>) => {
  const client = createClient();
  const result = await client.query<
    ClinicNotificationCountQuery,
    ClinicNotificationCountQueryVariables
  >({
    query: CLINIC_NOTIFICATION_COUNT_QUERY,
    variables: { filter },
  });
  const { data, errors } = result;
  const { clinicNotificationCount } = data;
  if (_.isNil(clinicNotificationCount) && errors?.length) {
    throw new Error(errors[0].message);
  }
  return clinicNotificationCount;
};

export default fetchClinicNotificationCount;
